// extracted by mini-css-extract-plugin
module.exports = {"label":"DatePickerInput_label__iWjxj","input":"DatePickerInput_input__ROi0K"};